import { pagesReducer } from './pages.reducer';
export * from './pages.types';
export * from './pages.actions';
export * from './pages.thunks';
export default pagesReducer;
